<div class="modal__content">
    <div class="popup-header">{{title}}</div>
    <div class="template-row">
        <span class="input-label">Template</span>
        <span class="template-name">{{templateName}}</span>
    </div>
    <div class="input-section">
        <label class="input-label" for="partner-api-alias-input">{{inputLabel}}</label>
        <input type="text" id="partner-api-alias-input" class="alias-input-box" maxlength="100"
            [class.has-error]="errorMessage"
            [attr.aria-invalid]="errorMessage ? true : null"
            [attr.aria-describedby]="errorMessage ? 'partner-api-alias-error' : 'partner-api-alias-helper'" [placeholder]="inputPlaceholder" [value]="inputValue"
            (input)="onInputChange($event.target.value)">
        <div *ngIf="errorMessage" id="partner-api-alias-error" class="error-message" role="alert">{{ errorMessage }}</div>
        <div *ngIf="!errorMessage" id="partner-api-alias-helper" class="helper-text">{{ helperText }}</div>
    </div>
</div>
<div class="modal__footer">
    <button type="button" class="btn btn-link btn-clear" [disabled]="!inputValue" (click)="onClear()">Clear</button>
    <span class="footer-actions">
        <button type="reset" class="btn btn-link" (click)="onCancel()">Cancel</button>
        <button type="button" class="btn btn-primary" [disabled]="isSaveDisabled" (click)="onConfirm()">Save</button>
    </span>
</div>
